const isDevelopment = process.env.NODE_ENV === "development";

export const logger = {
  log: (...args) => isDevelopment && console.log(...args),
  warn: (...args) => isDevelopment && console.warn(...args),
  error: (...args) => console.error(...args), // We always want to see errors
  info: (...args) => isDevelopment && console.info(...args),
  debug: (...args) => isDevelopment && console.debug(...args),
};

export function removeMultipleSpace(input = "") {
  const formattedString = input?.replace(/\s+/g, " ")?.trimStart();
  return formattedString;
}

export const safeString = (value) => {
  return typeof value === 'string' ? value : value == null ? "" : String(value);
};